var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.kon)?_c('video',{attrs:{"src":require('./test.mp4'),"autoplay":"","loop":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }